import { defineSlotRecipe } from '@chakra-ui/react';

const RadioGroup = defineSlotRecipe({
  slots: ['label', 'item', 'itemControl', 'itemIndicator'],
  base: {
    label: {
      _invalid: {
        color: 'podcastRed600',
      },
    },
    itemControl: {
      colorPalette: 'alituBrandPurple',

      _indeterminate: {
        bg: 'podcastRed',
      },

      _disabled: {
        opacity: 0.4,
      },

      _invalid: {
        colorPalette: 'red',
      },
    },
  },
});

export default RadioGroup;
